// import {
//     NEW_SCHEDULE_INTERVIEW_REQUEST,
//     NEW_SCHEDULE_INTERVIEW_SUCCESS,
//     NEW_SCHEDULE_INTERVIEW_FAIL,
// } from "../constants/AuthConstant";

// import axios from "axios";
// import { toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";



// // Action to schedule the interview
// export const NewScheduleInterviewAction = (data) => {
//   return function (dispatch) {
//     // Dispatch the loading state
//     dispatch({
//       type: NEW_SCHEDULE_INTERVIEW_REQUEST,
//       payload: true,
//     });

//     const OPTION = {
//       url: `${process.env.REACT_APP_API_PATH}/ebench/interview/add_interview`,
//       method: "POST",
//       data: data,
//       headers: {
//         "content-type": "application/json",
//       },
//     };

//     // Return the promise for chaining
//     return new Promise((resolve, reject) => {
//       axios(OPTION)
//         .then((res) => {
//           // Only call this once to avoid duplicate toasts
//           dispatch(scheduleContentPre(res?.data)); // Dispatch success once
//           resolve(res?.data); // Resolve the promise once
//         })
//         .catch((error) => {
//           // Dispatch failure and show error toast
//           dispatch({
//             type: NEW_SCHEDULE_INTERVIEW_FAIL,
//             payload: false,
//             error: error,
//             msg: "Failed to load the information",
//           });
//           // toast.error(error?.response?.data?.status?.message || "An error occurred.");
//           reject(error); // Reject the promise
//         });
//     });
//   };
// };

// // Success handler (show toast and dispatch success)
// export const scheduleContentPre = (data) => {
//   // Show success toast here to avoid duplicates
//   setTimeout(() => {
//     toast.success("Schedule Successfully!");
//   },1000)
//   return {
//     type: NEW_SCHEDULE_INTERVIEW_SUCCESS,
//     result: data,
//     payload: false,
//     msg: "SUCCESS",
//   };
// };
 

/// ============================= ======================================= ==============================

import {
  NEW_SCHEDULE_INTERVIEW_REQUEST,
  NEW_SCHEDULE_INTERVIEW_SUCCESS,
  NEW_SCHEDULE_INTERVIEW_FAIL,
} from "../constants/AuthConstant";

import axios from "axios";
import { toast } from "react-toastify";

// Action to schedule the interview
export const NewScheduleInterviewAction = (data) => {
  return (dispatch) => {
    // Dispatch the loading state
    dispatch({
      type: NEW_SCHEDULE_INTERVIEW_REQUEST,
      payload: true,
    });

    const OPTION = {
      url: `${process.env.REACT_APP_API_PATH}/ebench/interview/add_interview`,
      method: "POST",
      data: data,
      headers: {
        "content-type": "application/json",
      },
    };

    // Return a promise to maintain the chainable behavior
    return new Promise((resolve, reject) => {
      axios(OPTION)
        .then((res) => {
          // Dispatch the success action
          dispatch(scheduleContentPre(res?.data));

          // Resolve the promise with the response data
          resolve(res?.data);

          // Show success toast immediately
        })
        .catch((error) => {
          // Dispatch failure action and show error toast
          dispatch({
            type: NEW_SCHEDULE_INTERVIEW_FAIL,
            payload: false,
            error: error,
            msg: "Failed to load the information",
          });

          // Show error toast
          // toast.error(error?.response?.data?.status?.message || "An error occurred.");

          // Reject the promise with the error
          reject(error);
        });
    });
  };
};

// Success handler (dispatch success)
export const scheduleContentPre = (data) => {
  toast.success("Schedule Successfully!");

  return {
    type: NEW_SCHEDULE_INTERVIEW_SUCCESS,
    result: data,
    payload: false,
    msg: "SUCCESS",
  };
};
